import { useCallback, useEffect, useRef } from 'react'
import { withRouter } from "react-router"
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup';
import { sanitizeFormInput } from '../../../../functions/formFunctions';
import Translation from '../../../Translation/cont/Translation';
import FieldWrapper from '../../../forms/FieldWrapper';
import MultiselectCheckboxCinemasRow from '../../../forms/fields/MultiselectCheckboxCinemasRow';
import RadioButtonGroup from '../../../forms/fields/RadioButtonGroup';
import RadioButton from '../../../forms/fields/SingleSelectRadiobutton';
import sortCinemas from '../../../../functions/sortCinemas';
import positionConfig from '../../../../attribute-position-config.json';
import { ABSOLUTE_URL_PATTERN } from '../../functions/resolveAdLinkUrl';

const PushCreateForm = ({ cliCinemas, clientCinemaId, item, onUpdateItem, enabledCinemaIds, onResetForm, attachedItem, autofillRequest=false }) => {
    const lastAutofillRequestRef = useRef(false)

    const cliCinemasIdList = sortCinemas(clientCinemaId, cliCinemas)
    item["cinemasFilter"] = cliCinemasIdList

    const debouncedUpdate = useCallback(
        _.debounce((updatedValues) => {
            onUpdateItem(updatedValues);
        }, 300),
        []
      );

    return (
        <Formik
            initialValues={sanitizeFormInput(item)}
            validateOnBlur={false}
            validateOnChange={true}
            validateOnMount={true}
            validationSchema={validationSchema()}
        >
        {({values, setFieldValue}) => (
                <Form>
                        {
                            useEffect(() => {
                                let valid = validationSchema().isValidSync(sanitizeFormInput(values))
                                const updatedWithValidity = {
                                    ...values,
                                    valid: valid
                                };

                                debouncedUpdate(updatedWithValidity);

                                return () => {
                                    debouncedUpdate.cancel();
                                };
                        }, [values, values.cinemasFilter.length])}
                        {
                            useEffect(() => {
                                if(!autofillRequest || !autofillRequest.requestId || lastAutofillRequestRef.current === autofillRequest.requestId) {
                                    return
                                }

                                setFieldValue('title', autofillRequest.title || '', false)
                                setFieldValue('body', autofillRequest.body || '', false)
                                setFieldValue('link.url', autofillRequest.linkUrl || '', false)
                                setFieldValue('link.destinationType', autofillRequest.linkDestinationType || 'internal', false)
                                lastAutofillRequestRef.current = autofillRequest.requestId
                            }, [autofillRequest?.requestId])}
                        <ErrorMessage className="text-regular-color movie-error" name="style" component="div" />
                        <fieldset className="">
                            <FieldWrapper label={<Translation id="push_create_title" />} id="push-title" classes="field-text">
                                <Field name="title" type="text" maxLength="20" id="push-title" className="text-small-light input-text-box" />
                                <ErrorMessage name="title" component="div" />
                            </FieldWrapper>

                            <FieldWrapper label={<Translation id="push_create_body" />} info={<Translation id="push_create_body"/>} id="push-body" classes="field-textarea field-textarea-text">
                                <Field name="body" component="textarea" cols="50" wrap="hard" maxLength="220" id="push-body" className="text-small-light input-text-box" />
                                <ErrorMessage name="body" component="div" />
                            </FieldWrapper>

                            <>
                                <FieldWrapper label={<Translation id="content_link_url">URL</Translation>} id="push-link-url" classes="field-text push-link-url-field">
                                    <Field name="link.url" type="url" id="push-link-url" className="text-small-light input-text-box" placeholder="https://..." />
                                    <ErrorMessage name="link.url" component="div" />
                                </FieldWrapper>

                                {!!(values?.link?.url && `${values.link.url}`.trim().length > 0) && (
                                    <RadioButtonGroup
                                        label={<Translation id="content_link_target">URL öffnen in</Translation>}
                                        className="select-new-section-type push-link-target-left"
                                    >
                                        <ErrorMessage className="text-regular-color movie-error" name="link.destinationType" component="div" />
                                        {positionConfig.destinationType.map(({ id, transId }) => (
                                            <Field
                                                key={id}
                                                component={RadioButton}
                                                name="link.destinationType"
                                                id={id}
                                                label={<Translation id={transId} />}
                                                setFieldValue={setFieldValue}
                                            />
                                        ))}
                                    </RadioButtonGroup>
                                )}
                            </>
                        </fieldset>

                        {cliCinemas ? (
                            <MultiselectCheckboxCinemasRow clientCinemaId={clientCinemaId} cliCinemas={cliCinemas} enabledCinemaIds={enabledCinemaIds} />
                                ) : (
                                    ''
                                )
                        }

                </Form>
            )}

        </Formik>
    )
}

const validationSchema = () => Yup.object().shape({
    title: Yup.string().required(<Translation id="formik_field_required" />),
    body: Yup.string().required(<Translation id="formik_field_required" />),
    link: Yup.object().shape({
        url: Yup.string().url('Ungültige URL').matches(ABSOLUTE_URL_PATTERN, { message: 'Absolute URL erforderlich (https://…)', excludeEmptyString: true }).nullable(),
        destinationType: Yup.string().oneOf(['internal', 'external']).required(),
    })
});

export default withRouter(PushCreateForm)
